import React, { useState, forwardRef, useEffect } from "react";

import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import MenuItem from '@mui/material/MenuItem';

import { DataGrid, GridActionsCellItem} from '@mui/x-data-grid';

import Button from "components/CustomButtons/Button.js";
import GridItem from "components/Grid/GridItem.js";
import Loader from "components/Loader/Loader";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

import moment from "moment";
import "moment/locale/es";

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

moment.locale("es");

export default function Respaldos() {
  
  const useStyles = makeStyles(theme => ({
    ...dashboardStyle,
    cardTitle: {
      marginTop: "0",
      minHeight: "auto",
      fontWeight: "300",
      fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
      marginBottom: "3px",
      textDecoration: "none"
    },
    select: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      color: "#D2D2D2",
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "1.42857",
      letterSpacing: "unset",
      "&:before": {
        borderColor: "#D2D2D2",
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "1.42857",
        letterSpacing: "unset"
      },
      "&:after": {
        borderColor: "#D2D2D2",
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "1.42857",
        letterSpacing: "unset"
      }
    },
    container: {
      textAlign: "center"
    },
    content: {
      display: "inline-flex",
      padding: "10px",
      alignItems: "center"
    },
    paddingBottomCard: {
      paddingBottom: "40px"
    },
    marginRight: {
      marginRight: "10px"
    },
    marginBottom: {
      marginBottom: "50px"
    },
    formControl: {
      marginTop: theme.spacing(3.5),
      minWidth: "100%"
    },
    formControl2: {
      minWidth: "100%",
      marginTop: theme.spacing(5)
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    }
  }));

  const classes = useStyles();

  const [load, setLoad] = useState(false);

  const [color, setColor] = useState("");
  const [message, setMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const [Respaldos, setRespaldos] = useState([]);

  const column = [
    { headerName: "Nombre archivo", field: "FileName", width: 250, editable: false },
    { field: 'SizeFormatted', headerName: 'Tamaño', width: 150, editable: false},
    { field: 'ModifiedDate', headerName: 'Fecha', width: 250, editable: false},
    {
        field: 'actions',
        type: 'actions',
        headerName: 'Acciones',
        width: 150,
        cellClassName: 'actions',
        getActions: ({row}) => {
          return [
              <GridActionsCellItem
                icon={<ArrowCircleDownIcon />}
                label="Editar"
                className="textPrimary"
                onClick={DescargarArchivo(row)}
                color="inherit"
                key="edit"
              />
          ];
        },
      }
  ];

  const DescargarArchivo = (row) => () => {
    setLoad(true);
    Login()
    .then(result => {
      let token = result.token;

      DescargaRespaldo(row, token)
      .then(blob => {
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = row.FileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        setLoad(false);
      });
    });
  }

  const sendSnackBar = (pmessage, pcolor) => {
    setOpenSnackbar(true);
    setColor(pcolor);
    setMessage(pmessage);
  };
  
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  const handeSubmit = event => {
    event.preventDefault();
    try{
        setLoad(true);

        Login()
        .then(result => {
          ObtieneRespaldos(result.token)
          .then(result => {
              let respaldos = result.respaldos.map((element, index) => {
                element.id = index;

                return element;
              });

              setRespaldos(respaldos);
              setLoad(false);
          }).catch(error => console.log(error));
        }).catch(error => sendSnackBar("Error de conexión", "error"));
    } catch(error){
        sendSnackBar("Error de conexión", "error");
        setLoad(false);
    }
  };

  const ObtieneRespaldos = async (token) => {
    let dataResponse;
    try {
        let header = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Respaldo/ObtieneRespaldos",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const DescargaRespaldo = async (data, token) => {
    let dataResponse;
    try {
        let header = {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Respaldo/DescargaRespaldo?file=" + data.FileName,
            header
        );

        dataResponse = await response.blob();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const Login = async () => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify({UserName: process.env.REACT_APP_USER, Password: process.env.REACT_APP_PASS}),
            headers: {
                "Content-Type": "application/json"
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Login",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  useEffect(() => {
    setLoad(true);
    Login()
    .then(result => {
      let token = result.token;

      ObtieneRespaldos(token)
      .then(result => {
          let respaldos = result.respaldos.map((element, index) => {
            element.id = index;

            return element;
          });

          setRespaldos(respaldos);
          setLoad(false);
      });
    });
  }, []);

  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Grid className={classes.marginBottom}>
          <Grid container spacing={3} style={{marginLeft: "1px"}}>
            <GridItem xs={12} sm={12} md={2}>
              <Button
                onClick={e => {
                  handeSubmit(e);
                }}
                color="info"
              >
                Buscar
              </Button>
            </GridItem>
          </Grid>
        </Grid>
      </LocalizationProvider>
        <DataGrid
            columns={column}
            rows={Respaldos}
            sx={{
                '& .MuiInputBase-root':
                {
                    padding: '10px 30px 10px 0 !important',
                    width: 'auto !important'
                },
                '& .MuiInputBase-root svg':
                {
                    display: 'block',
                    width: '2em',
                    height: '2em',
                    top: 'calc(50% - 1em)'
                },
            }}
            slotProps={{ pagination: { 
                labelRowsPerPage: "Registros por página",
                labelDisplayedRows: ({ from, to, count }) => `${from}–${to} de ${count !== -1 ? count : `más que ${to}`}`
                } 
            }}
        />
        <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "right" }} open={openSnackbar} onClose={handleClose} autoHideDuration={6000}>
            <Alert onClose={handleClose} severity={color} sx={{ width: '100%' }}>
                {message}
            </Alert>
        </Snackbar>
        <Loader load={load} />
    </div>
  );
}